import React from 'react';

const ClientWidget = ({ publicUrl, client, clientTypeIcon }) => {
    const defaultIcons = {
        "personas_naturales": <i className="fa fa-home ltn__secondary-color" style={{ fontSize: '100px' }} />,
        "empresariales": <i className="fa fa-building ltn__secondary-color" style={{ fontSize: '100px' }} />,
        "institucionales": <i className="fa fa-university ltn__secondary-color" style={{ fontSize: '100px' }} />
    };

    const clientImage = client.image ? (
        <img
            src={publicUrl + client.image}
            alt="Client Perfil"
            style={{
                borderRadius: '50%',
                width: '150px',
                height: '150px',
                objectFit: 'cover',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}
        />
    ) : (
        defaultIcons[clientTypeIcon]
    );

    return (
        <div className="widget ltn__client-widget">
            <div className="ltn__client-widget-inner text-center">
                <div className="client-image mb-3">
                    {clientImage}
                </div>
                <div className="client-info">
                    <h4 className="mb-1">{client.name}</h4>
                    <p className="mb-3" style={{ color: '#666', lineHeight: '1.3' }}>
                        {client.description}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ClientWidget;